<!--navbar padrão-->
<template>
  <div class="mosiaMenu">
    <el-dropdown trigger="click" @command="goToApp" style="width: 100%;">
      <div class="el-dropdown-link mosiaLogo" style="width: 100%; margin: 0;">
        <img v-if="!idConfigClienteApp" alt src="@/assets/img/logo/simbolo-mosia.png"/>
        <div v-else-if="aplicacaoIcone.image" class="mosiaLogo" style="max-height: 35px; max-width: 35px;">
          <img :src="aplicacaoIcone.image" alt="icon" style="max-height: 100%; max-width: 100%;"/>
        </div>
        <div v-else class="mosiaLogo"  style="max-height: 35px; max-width: 35px;">
          <i class="material-symbols-rounded fill" style="font-size: 40px;">{{
              aplicacaoIcone.icon
            }}</i>
        </div>
        <i class="material-symbols-rounded" style="font-size: 16px;">arrow_drop_down</i>
      </div>
      <el-dropdown-menu slot="dropdown" style="width: 280px; padding: 15px;">
        <el-dropdown-item
          command="/home"
        >
          <div style="display:flex; flex-flow: row nowrap; column-gap: 10px; padding: 5px 0;">
            <div style="max-height: 36px; max-width: 36px;">
              <div class="mosiaLogo" style="max-height: 100%; max-width: 100%;">
                <img alt="icon" src="@/assets/img/logo/simbolo-mosia.png" style="max-height: 100%; max-width: 100%;"/>
              </div>
            </div>
            <div>
              <span class="dropdown-title">Início</span>
            </div>
          </div>
        </el-dropdown-item>

        <el-dropdown-item
          v-for="app in apliacacaoMenu"
          :key="app.idConfigClienteApp"
          :command="app.routerPath"
        >
          <div style="display:flex; flex-flow: row nowrap; column-gap: 10px; padding: 5px 0;">
            <div style="max-height: 36px; max-width: 36px;">
              <div v-if="app.image" class="mosiaLogo" style="max-height: 100%; max-width: 100%;">
                <img :src="app.image" alt="icon" style="max-height: 100%; max-width: 100%;"/>
              </div>
              <div v-else class="mosiaLogo" style="max-height: 100%; max-width: 100%;">
                <i :class="(app.iconFill)?'fill':''" class="material-symbols-rounded" style="font-size: 40px;">{{
                    app.icon
                  }}</i>
              </div>
            </div>
            <div style="display:flex; flex-flow: column; justify-content: center;">
              <span class="dropdown-title">{{ app.name }}</span>
              <span class="dropdown-subtitle" v-if="app.nameApplication"> {{ app.nameApplication }}</span>
            </div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <div class="mosiaNavbar">
      <el-menu v-if="idConfigClienteApp" :default-active="String(getCurrentMenu.idMenu)" :router=true :unique-opened=true mode="vertical">
        <template>
          <el-menu-item
            v-for="(menu, index) in filteredMenus"
            :key="index"
            :class="{ 'is-active': menu.routerName === queryGroup }"
            :index='String(menu.idMenu)'
            :route="getPath(menu)"
          >
            <i :class="(menu.iconFill)?'fill':''" class="material-symbols-rounded">{{ menu.icon }}</i>
            <p v-html="menu.name">
            </p>
          </el-menu-item>
        </template>
      </el-menu>
      <el-menu v-else :router=true :unique-opened=true mode="vertical">
        <template>
          <el-menu-item
            v-for="(app, index) in apliacacaoMenu"
            :key="index"
            :index='String(app.idConfigClienteApp)'
            :route="app.routerPath"
          >
            <div style="max-height: 36px; max-width: 36px;">
              <div v-if="app.image" class="mosiaLogo" style="max-height: 100%; max-width: 100%;">
                <img :src="app.image" alt="icon" style="max-height: 100%; max-width: 100%;"/>
              </div>
              <div v-else class="mosiaLogo" style="max-height: 100%; max-width: 100%;">
                <i :class="(app.iconFill)?'fill':''" class="material-symbols-rounded" style="font-size: 40px;">{{
                    app.icon
                  }}</i>
              </div>
            </div>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex'
import enumTipoAplicacao from '@mobilesaude/frontend_libs/enums/enumTipoAplicacao'

export default {
  name: 'Navbar',
  props: {
    idConfigClienteApp: {
      type: [String, Number],
      required: false
    }
  },
  data () {
    return {
      isHomeActive: false,
      activeLink: null
    }
  },
  computed: {
    ...mapState([
      'menus'
    ]),
    ...mapState('login', [
      'permissaoRouter'
    ]),
    ...mapGetters([
      'currentMenu'
    ]),
    ...mapState('SelecionaAplicacao', ['aplicacoes']),
    ...mapGetters('SelecionaAplicacao', ['applicationMenu']),
    menusFlitrados () {
      if (Array.isArray(this.permissaoRouter) && this.permissaoRouter.length > 0) {
        return this.menus.map(menu => {
          return {
            ...menu,
            childs: menu.childs.filter(child => this.permissaoRouter.includes(child.routerName))
          }
        })
      }
      return this.menus
    },
    apliacacaoMenu () {
      if (!this.applicationMenu || !this.applicationMenu[0] || !this.applicationMenu[0].childs) {
        return []
      }

      return this.applicationMenu[0].childs
    },
    aplicacao () {
      if (!this.idConfigClienteApp) {
        return null
      }
      return this.aplicacoes.find(
        app => `${app.id_cliente_app}` === this.idConfigClienteApp
      ) || null
    },
    aplicacaoIcone () {
      if (!this.aplicacao) {
        return {
          name: 'Configurações globais',
          applicationName: '',
          icon: 'settings'
        }
      }
      return {
        name: this.aplicacao.descricao,
        applicationName: this.aplicacao.descricao_app,
        image: this.aplicacao.icon
      }
    },
    queryGroup () {
      return this.$route.query.group || ''
    },
    getCurrentMenu () {
      return this.currentMenu
    },
    filteredMenus () {
      if (`${this.idConfigClienteApp}`) {
        if (this.aplicacao && this.aplicacao.tipo_aplicacao === enumTipoAplicacao.tipoPlataformas.atendimento) {
          return []
        }
        let menusFiltered = [...this.menusFlitrados]

        if (this.aplicacao) {
          menusFiltered = menusFiltered.map(menu => ({
            ...menu,
            childs: menu.childs.filter(child => child.tipoAplicacao.includes(this.aplicacao.tipo_aplicacao))
          })).filter(menu => menu.childs.length > 0 || menu.routerName === 'Home')
        } else {
          menusFiltered = menusFiltered.map(menu => ({
            ...menu,
            childs: menu.childs.filter(child => child.tipoAplicacao.length === 0)
          })).filter(menu => menu.childs.length > 0 || menu.routerName === 'Home')
        }
        return menusFiltered
      }
      return []
    }
  },
  methods: {
    getPath (menu) {
      if (!menu) {
        return {}
      }

      const route = {}

      if (this.$route.name !== 'PainelConfiguracoes' && menu.routerPath) {
        // Perform actions if $route.name is 'PainelConfiguracoes'
        route.path = menu.routerPath.replace(':idConfigClienteApp', this.idConfigClienteApp)
      }
      route.query = {
        group: menu.routerName
      }
      return route
    },
    goToApp (path) {
      if (path !== this.$route.path) {
        this.$router.push({ path })
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap')
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200')
@import '../navbar-configuracoes/navbar'

.dropdown-title
  font: normal normal 600 14px/18px Nunito
  letter-spacing: 0
  color: #000000

.dropdown-subtitle
  font: normal normal 600 11px/18px Nunito
  letter-spacing: 0
  color: #000000

</style>
